import { NodeCustomizer } from "@rromikas/configurio";
import uniqid from "uniqid";

export const generateNodeCustomizer = (targetIndex: number, meshName: string): NodeCustomizer => {
  return {
    name: meshName,
    targetIndexes: [targetIndex],
    id: uniqid(),
    color: {
      label: "",
      options: [],
    },
    material: {
      label: "",
      options: [],
    },
  };
};
